import { render } from "./StaffTelemetryPopup.vue?vue&type=template&id=474d433a&scoped=true"
import script from "./StaffTelemetryPopup.vue?vue&type=script&lang=js"
export * from "./StaffTelemetryPopup.vue?vue&type=script&lang=js"

import "./StaffTelemetryPopup.vue?vue&type=style&index=0&id=474d433a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474d433a"]])

export default __exports__